import { SupportAttendanceService } from './../../../../shared/services/support-attendance/support-attendance.service';

export class SupportDetailsCtrl {
  static $inject = ['SupportAttendanceService'];

  // Bindings
  private support;
  private studentSupports;
  private attendanceRecords;

  public attendanceSummary;
  public attendanceRate;
  public missingLogsCount;
  public attIsOnTrack;
  public logsAreOnTrack;
  public isCompleted;

  constructor(private supportAttService: SupportAttendanceService) {}

  $onInit() {
    this.attendanceSummary = this.supportAttService.summarizeAttendanceData(this.attendanceRecords, 'supportId')[0];
    this.attendanceRate = this.getAttendanceRate(this.attendanceSummary);
    this.missingLogsCount = this.getMissingLogsCount(this.support, this.attendanceRecords, this.studentSupports);
    this.isCompleted = this.support.status === 'COMPLETED';
    // For on/off track color coding
    this.attIsOnTrack = this.attendanceRate > 80;
    this.logsAreOnTrack = this.missingLogsCount === 0;
  }

  getAttendanceRate(attendanceSummary): number {
    if (!attendanceSummary) return 0;
    return attendanceSummary.percentPresAndLate;
  }

  getMissingLogsCount(support, attendanceRecords, studentSupports): number {
    const includeToday = true;
    const missingLogDates = this.supportAttService.getMissingAttendanceDates(
      support,
      attendanceRecords,
      studentSupports,
      includeToday,
    );
    return missingLogDates.filter(obj => obj.isUnlogged).length;
  }
}
